/*
 * Code generated by maegi. DO NOT EDIT.
 */

import type React from "react";

export const Filter24 = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h24v24H0z" />
      <path
        fill="currentColor"
        d="M9 4v7.171a3.001 3.001 0 0 1 0 5.658V20H7v-3.17a3.001 3.001 0 0 1 0-5.66V4zm8 0v3.171a3.001 3.001 0 0 1 0 5.658V20h-2v-7.17a3.001 3.001 0 0 1 0-5.66V4z"
      />
    </g>
  </svg>
);

export const __descriptor_Filter = {
  name: "Filter",
  instances: [{ size: 24, Component: Filter24 }],
} as const;
